var _defs, _rect, _g, _g2, _g3, _g4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTranslateme2Text(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 360",
    preserveAspectRatio: "xMidYMid slice",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0f172a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#1e293b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#312e81"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "accent",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#a78bfa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#22d3ee"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "glow",
    x: "-30%",
    y: "-30%",
    width: "160%",
    height: "160%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "blur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 360,
    fill: "url(#bg)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.35,
    stroke: "url(#accent)",
    strokeWidth: 1.2,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 90 Q150 40 300 90 T600 90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 130 Q150 80 300 130 T600 130"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 170 Q150 120 300 170 T600 170"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(60 130)",
    filter: "url(#glow)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 38,
    fill: "none",
    stroke: "url(#accent)",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 18,
    width: 20,
    height: 34,
    rx: 10,
    fill: "url(#accent)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 44 a18 18 0 0 0 36 0",
    fill: "none",
    stroke: "url(#accent)",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 62,
    x2: 40,
    y2: 74,
    stroke: "url(#accent)",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 28,
    y1: 74,
    x2: 52,
    y2: 74,
    stroke: "url(#accent)",
    strokeWidth: 2.5
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(180 145)",
    fontFamily: "-apple-system, Segoe UI, Roboto, sans-serif"
  }, /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 0,
    fill: "#ffffff",
    fontSize: 34,
    fontWeight: 700
  }, "TranslateMe2Text"), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 32,
    fill: "#cbd5e1",
    fontSize: 16,
    fontWeight: 500
  }, "Real-Time Translation Platform"), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 56)",
    fontSize: 13,
    fill: "url(#accent)",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 0
  }, "EN"), /*#__PURE__*/React.createElement("text", {
    x: 36,
    y: 0,
    fill: "#94a3b8"
  }, "\u2192"), /*#__PURE__*/React.createElement("text", {
    x: 58,
    y: 0
  }, "ES"), /*#__PURE__*/React.createElement("text", {
    x: 92,
    y: 0,
    fill: "#94a3b8"
  }, "\u2192"), /*#__PURE__*/React.createElement("text", {
    x: 114,
    y: 0
  }, "PT"), /*#__PURE__*/React.createElement("text", {
    x: 146,
    y: 0,
    fill: "#94a3b8"
  }, "\u2192"), /*#__PURE__*/React.createElement("text", {
    x: 168,
    y: 0
  }, "DE")))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(60 260)",
    fontFamily: "-apple-system, Segoe UI, Roboto, sans-serif",
    fontSize: 13,
    fill: "#e2e8f0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -10,
    y: -22,
    width: 118,
    height: 32,
    rx: 16,
    fill: "#ffffff14",
    stroke: "url(#accent)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 0,
    fontWeight: 600
  }, "~400ms latency"), /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: -22,
    width: 120,
    height: 32,
    rx: 16,
    fill: "#ffffff14",
    stroke: "url(#accent)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 130,
    y: 0,
    fontWeight: 600
  }, "90% accuracy"), /*#__PURE__*/React.createElement("rect", {
    x: 250,
    y: -22,
    width: 118,
    height: 32,
    rx: 16,
    fill: "#ffffff14",
    stroke: "url(#accent)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 260,
    y: 0,
    fontWeight: 600
  }, "2+ languages"), /*#__PURE__*/React.createElement("rect", {
    x: 380,
    y: -22,
    width: 120,
    height: 32,
    rx: 16,
    fill: "#ffffff14",
    stroke: "url(#accent)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 390,
    y: 0,
    fontWeight: 600
  }, "Zero install"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTranslateme2Text);
export default __webpack_public_path__ + "static/media/translateme2text.a4ac8fd15f59d1c8db1484a217bf98dd.svg";
export { ForwardRef as ReactComponent };